__turbopack_context__.v({
  "arenaWord": "HeroBlock-module-scss-module__0FjYdW__arenaWord",
  "arenaWordFilter": "HeroBlock-module-scss-module__0FjYdW__arenaWordFilter",
  "background": "HeroBlock-module-scss-module__0FjYdW__background",
  "backgroundHighlight": "HeroBlock-module-scss-module__0FjYdW__backgroundHighlight",
  "backgroundImage": "HeroBlock-module-scss-module__0FjYdW__backgroundImage",
  "backgroundPicture": "HeroBlock-module-scss-module__0FjYdW__backgroundPicture",
  "bottomFade": "HeroBlock-module-scss-module__0FjYdW__bottomFade",
  "hero": "HeroBlock-module-scss-module__0FjYdW__hero",
  "heroContentAboveGrain": "HeroBlock-module-scss-module__0FjYdW__heroContentAboveGrain",
  "heroFlushBelowHeader": "HeroBlock-module-scss-module__0FjYdW__heroFlushBelowHeader",
  "heroGrainOverlay": "HeroBlock-module-scss-module__0FjYdW__heroGrainOverlay",
  "heroHome": "HeroBlock-module-scss-module__0FjYdW__heroHome",
});
